export const sendTenantOtpMutation = (confirmationChannel, phoneNumber, email) => {
  const mutation = `
    mutation{
      sendTenantOtp(confirmationChannel:"${confirmationChannel}", phoneNumber:"${phoneNumber}", email:"${email}"){
          errorMessage
          successMessage
          success
          otpCodeExpiry
      }  
    }
    
    `;
  return mutation;
};

export const verifyTenantOtpMutation = (otpCode, phoneNumber, email) => {
  const mutation = `
    mutation{
      verifyTenantOtp(otpCode:"${otpCode}", phoneNumber:"${phoneNumber}", email:"${email}"){
          errorMessage
          success
          token
          user{
            username
          }
      }  
    }
    
    `;
  return mutation;
};
